function updateReturnsContentSteps() {
  const steps = Array.from(document.querySelectorAll('.returns-content .return-steps[data-country-code]'));
  if (steps.length < 1) {
    return;
  }
  GeoRedirect.fetchData(function (data) {
    const currentCountry = data.country_code;
    const currentCountrySteps = steps.filter(e => e.dataset.countryCode === currentCountry);
    if (currentCountrySteps.length < 1) {
      return;
    }
    currentCountrySteps.forEach(e => {
      e.classList.add('return-steps--visible');
      if (e.parentElement) {
        e.parentElement.querySelectorAll('.return-steps[data-country-default]').forEach(e => e.classList.add('return-steps--hidden'));
      }
    });
  });
}

function updateReturnsTable() {
  $('.wb-returns__show-rates').click(function(){
    $('.wb-returns__show-rates').hide();
    $('.return_table-wrapper').slideToggle(200);
  });

  GeoRedirect.fetchData(function (data) {
    const currentCountry = data.country_code;
    let tr = $('.return_table-wrapper tr[data-country-code="' + currentCountry + '"]').first();
    const countryMatch = Boolean(tr.length);
    if (countryMatch) {
      if (tr.find('td').last().html().indexOf('<br>') !== -1) {
        let costs = tr.find('td').last().html().split('<br>');
        let storeCreditCost = costs[0];
        let refundCost = costs[1];

        $('.return_refund_cost').text(refundCost);
        if (['FREE', 'KOSTENLOS', 'GRATUIT', 'GRATIS'].indexOf(storeCreditCost.trim().toUpperCase()) !== -1) {
          $('.return_store_credit').hide();
          $('.return_store_credit_free').show();
        } else {
          $('.return_store_credit_cost').text(storeCreditCost);
          $('.return_store_credit').show();
          $('.return_store_credit_free').hide();
        }
      } else {
        $('.return_refund_cost').text(tr.find('td').last().text());
      }
      $('.return_country').text(tr.find('td').first().text());
      $('.returns-section-hint').show();
    } else {
      $('.wb-returns__show-rates').hide(0);
      $('.return_table-wrapper').slideToggle(200);
    }
  });
}